import React from 'react'
import { Box, Typography, Link, useTheme, useMediaQuery } from '@mui/material'
import { useTranslation } from 'react-i18next'
import { Link as RouterLink } from 'react-router-dom'
import { ListProperty } from 'types'
import ImageCarousel from './ImagesCarousel'
import OverflowTypography from 'shared/OverflowTypography'
import { sortBy } from 'lodash'

interface Props {
  item: ListProperty
}

const ListCard = (props: Props) => {
  const { t } = useTranslation()
  const { item } = props

  const ALL_FIRST_IMAGES = React.useMemo(() => {
    return (
      sortBy(item?.userFavorites, (item) => item.dateTimeCreated)
        ?.map((item) => item.firstImageUrl)
        .filter((item): item is string => !!item) ?? []
    )
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [item.id])

  const theme = useTheme()

  const matchesSM = useMediaQuery(theme.breakpoints.down(900))

  return (
    <>
      <Box
        sx={{
          bgcolor: 'white.main',
          width: matchesSM ? 176 : 264,
          minHeight: { xs: '248px', lg: '372px' },
          border: '1px solid #E7E7E7',
          borderRadius: '20px',
          boxShadow: '3px 3px 8px rgba(9, 9, 9, 0.35)',
          borderColor: 'transparent',
          '&:hover': { borderColor: 'primary.main' },
          px: { xs: '6px', sm: '6px', lg: '12px' },
          pt: { xs: '6px', lg: '12px' },
          pb: { xs: '0px', lg: '12px' },
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'stretch',
        }}
      >
        <Box
          sx={{
            mx: 'auto',
            width: matchesSM ? 160 : 236,
            height: matchesSM ? 125 : 188,
          }}
        >
          <ImageCarousel
            options={ALL_FIRST_IMAGES}
            width={matchesSM ? 160 : 236}
            height={matchesSM ? 125 : 188}
            errorHeight={'130px'}
            errorWidth={'130px'}
          />
        </Box>
        <Link
          component={RouterLink}
          to={`/lists/${item.id}`}
          underline="none"
          sx={{
            color: 'text.primary',
            fontWeight: 700,
            flexGrow: 1,
            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'space-between',
            pt: { xs: '6px', lg: '32px' },
            pb: { xs: '16px', lg: '32px' },
          }}
        >
          <OverflowTypography
            maxWidth={'100%'}
            label={item.name}
            textAlign={'center'}
            TooltipProps={{ placement: 'top' }}
            sx={{
              fontWeight: { xs: 400, lg: 700 },
              fontSize: { xs: '16px', lg: '18px' },
              lineHeight: { xs: '19px', lg: '21px' },
              textAlign: 'center',
            }}
          >
            {item.name}
          </OverflowTypography>

          <Typography
            textAlign="center"
            sx={{
              fontWeight: 500,
              fontSize: '14px',
              lineHeight: { xs: '16px', md: '16.4px' },
              mt: { xs: '10px', md: '32px' },
            }}
          >
            {t(`enums.listCategory.${item?.listCategory}`)}
            <br />
            {item?.userFavorites?.length
              ? t('listCard.ads', {
                  count: item?.userFavorites?.length,
                })
              : '-'}
          </Typography>
        </Link>
      </Box>
    </>
  )
}

export default ListCard
